import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from 'src/utils/Loader/spinner';
import { LocalStorage } from 'src/utils/storage/local-storage';
import { useToaster } from 'src/utils/toaster/toasterContext';
import OrganizationDialog from './create-org-dialog-component';
import BrandDialog from './create-brand-dialog.component';
import IntegrationDialog from './integration-dialog-component';
import { CommonHelper } from 'src/utils/commonHelper';


const GetStartedComponent = () => {
  const navigate = useNavigate();
  const { showToast } = useToaster();

  const [onBoardingInfo, setOnBoardingInfo] = useState(() => {
    const saved = LocalStorage.getItem('get_started');
    return saved ? JSON.parse(saved) : null;
  });

  const [isLoader, setLoader] = useState(true);

  useEffect(() => {
     if (!onBoardingInfo) {
      navigate(CommonHelper.DefaultPermissionRoute);
    }
    if (
      onBoardingInfo?.org_skipped &&
      onBoardingInfo?.brand_skipped &&
      onBoardingInfo?.integration_skipped
    ) {
     navigate(CommonHelper.DefaultPermissionRoute);
    }

    // If all done (or skipped individually) -> onboarding completed
    const isCompleted =
      (onBoardingInfo?.org_done || onBoardingInfo?.org_skipped) &&
      (onBoardingInfo?.brand_done || onBoardingInfo?.brand_skipped) &&
      (onBoardingInfo?.integration_done || onBoardingInfo?.integration_skipped);

    if (isCompleted) {
     navigate(CommonHelper.DefaultPermissionRoute);
    }

    setLoader(false);
  }, [onBoardingInfo]);

  const updateOnboarding = (updated) => {
    LocalStorage.setItem('get_started', JSON.stringify(updated));
    setOnBoardingInfo(updated);
  };

  const handleSkip = (type) => {
    updateOnboarding({ ...onBoardingInfo, [`${type}_skipped`]: true });
  };

  const manualOnBoardingSuccessCallback = (data, message, type) => {
    const updated = {
      ...onBoardingInfo,
      [`${type}_done`]: true,
      [`${type}_skipped`]: false,  // mark completed properly
    };

    updateOnboarding(updated);

    if (message) showToast(message, 's');
  };

  const failureCallback = (message) => {
    if (message) showToast(message, 'e');
  };

  return isLoader ? (
    <Spinner />
  ) : (
    <>
      <OrganizationDialog
        handleSkip={() => handleSkip('org')}
        failureCallback={failureCallback}
        successCallback={manualOnBoardingSuccessCallback}
        showToast={showToast}
        onBoardingInfo={onBoardingInfo}
      />

      <BrandDialog
        handleSkip={() => handleSkip('brand')}
        failureCallback={failureCallback}
        successCallback={manualOnBoardingSuccessCallback}
        showToast={showToast}
        onBoardingInfo={onBoardingInfo}
      />

      <IntegrationDialog
        handleSkip={() => handleSkip('integration')}
        successCallback={manualOnBoardingSuccessCallback}
        onBoardingInfo={onBoardingInfo}
      />
    </>
  );
};

export default GetStartedComponent;
